import { useEffect, useState } from "react";
import {
  Flex,
  Space,
  Spin,
  Grid,
  Typography,
  message,
  Form,
  Input,
  Button,
  Modal,
} from "antd";
import {
  CheckCircleFilled,
  CloseCircleFilled,
  LoadingOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-number-input/input";

import publicDataServices from "../../../APIs/publicDataServices";

const { Title } = Typography;
const { useBreakpoint } = Grid;

const ContactUs = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const screens = useBreakpoint();

  const [messageApi, contextHolder] = message.useMessage();

  const [hpNumberError, setHpNumberError] = useState(false);
  const [phoneValue, setPhoneValue] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  const handleSubmit = async () => {
    setHpNumberError(false);

    try {
      const values = await form.getFieldsValue();

      if (
        values.phoneNumber === undefined ||
        values.phoneNumber.trim() === ""
      ) {
        console.log("Phone number is undefined");

        setHpNumberError(true);

        await form.validateFields();

        return;
      }

      setIsLoading(true);

      await form.validateFields();

      console.log("Form Values:", values);

      const submitResult = await publicDataServices.contactUs(values);

      console.log("Submit Result:", submitResult);

      if (submitResult?.status === 200) {
        // messageApi.success(
        //   submitResult?.data?.message || "Submitted successfully!"
        // );

        setSubmitMessage(
          submitResult?.data?.message || "Submitted successfully!"
        );

        setIsModalOpen(true);

        // form.resetFields();

        // setPhoneValue("");

        return;
      } else {
        messageApi.error(
          submitResult?.data?.message || "An error occurred. Please try again."
        );

        setTimeout(() => {
          setIsLoading(false);
        }, 1000);

        return;
      }
    } catch (error) {
      console.log("handleSubmit Failed:", error);

      if (error?.errorFields && error?.errorFields.length > 0) {
        messageApi.error("Please fill in the required fields.");

        setTimeout(() => {
          setIsLoading(false);
        }, 1000);

        return;
      }

      messageApi.error(
        error.response?.data?.message ||
          error?.message ||
          "An error occurred. Please try again."
      );

      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }
  };

  return (
    <Space direction="vertical" className="page-container" size={0}>
      {isLoading && (
        <Spin
          spinning={isLoading}
          indicator={<LoadingOutlined spin />}
          fullscreen
        />
      )}

      {contextHolder}

      <Title
        level={2}
        style={{
          color: "#002753",
          marginTop: 30,
          marginBottom: 15,
          marginLeft: "auto",
          marginRight: "auto",
          width: screens.xs ? "100%" : 500,
        }}
      >
        <b>Contact Us</b>
      </Title>

      <Form
        form={form}
        name="contact-us"
        layout="vertical"
        style={{
          width: screens.xs ? "100%" : 500,
          marginBottom: screens.xs ? 40 : 50,
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "" }]}
          hasFeedback
        >
          <Input placeholder="Your Name" />
        </Form.Item>

        <Form.Item
          label="Email Address"
          name="emailAddress"
          rules={[
            { required: true, message: "" },
            { type: "email", message: "" },
          ]}
          hasFeedback
        >
          <Input placeholder="Your Email" />
        </Form.Item>

        <span
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            position: "relative",
            marginBottom: 24,
          }}
        >
          <Form.Item
            label="Phone Number"
            name="phoneNumber"
            rules={[{ required: true, message: "" }]}
            hasFeedback
            style={{ width: "100%", marginBottom: 0 }}
          >
            <PhoneInput
              className="custom-phone-input ant-input"
              country="MY"
              international
              withCountryCallingCode
              placeholder="+60"
              value={phoneValue}
              onChange={(value) => {
                const isValid = /^\+?\d*$/.test(value || "");

                if (isValid) {
                  setPhoneValue(value);
                } else {
                  setPhoneValue(""); // clear it if invalid (letter entered)
                }
              }}
              style={{
                width: "100%",
                borderRadius: 6,
                border:
                  hpNumberError &&
                  form.getFieldError("phoneNumber").length === 0
                    ? "1px solid #ff4d4f"
                    : "1px solid #d9d9d9",
                padding: "8px 11px",
                fontSize: 14,
              }}
            />
          </Form.Item>

          {(hpNumberError || /^\+\d+$/.test((phoneValue || "").trim())) && (
            <span
              style={{
                position: "absolute",
                right: 13,
                top: 36,
                pointerEvents: "none",
              }}
            >
              {hpNumberError ? (
                <CloseCircleFilled style={{ color: "#ff4d4f", fontSize: 14 }} />
              ) : (
                <CheckCircleFilled style={{ color: "#52c41a", fontSize: 14 }} />
              )}
            </span>
          )}
        </span>

        <Form.Item
          label="Address"
          name="address"
          rules={[{ required: true, message: "" }]}
          hasFeedback
        >
          <Input.TextArea rows={2} placeholder="Your Address" />
        </Form.Item>

        <Form.Item
          label="Message"
          name="message"
          rules={[{ required: true, message: "" }]}
          hasFeedback
        >
          <Input.TextArea rows={4} placeholder="Your Message" />
        </Form.Item>

        <Button
          type="primary"
          htmlType="submit"
          style={{
            backgroundColor: "#FFDC00",
            width: "100%",
            height: 40,
            // marginTop: 20,
            color: "black",
          }}
          loading={isLoading}
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </Form>

      <Title
        level={5}
        style={{
          color: "#002753",
          marginTop: screens.xs ? 0 : 50,
          textAlign: screens.xs ? "left" : "center",
          fontSize: screens.xs ? 20 : 24,
        }}
      >
        <b>
          Need more than just support? Browse our products or visit a store near
          you.
        </b>
      </Title>

      <Flex
        justify="center"
        gap={10}
        style={{
          marginBottom: screens.xs ? 0 : 50,
        }}
      >
        <Button
          type="primary"
          style={{
            backgroundColor: "#EF5F17",
            width: screens.xs ? "100%" : 200,
            height: 40,
            marginTop: 20,
            fontSize: 16,
          }}
          onClick={() => navigate("/products")}
        >
          Shop Now
        </Button>

        <Button
          type="primary"
          style={{
            backgroundColor: "#EF5F17",
            width: screens.xs ? "100%" : 200,
            height: 40,
            marginTop: 20,
            fontSize: 16,
          }}
          onClick={() => navigate("/store-locations")}
        >
          Find a Store
        </Button>
      </Flex>

      {/* Success Modal */}
      <Modal
        centered
        title="Success"
        open={isModalOpen}
        onOk={() => {
          setIsModalOpen(false);

          form.resetFields();

          setPhoneValue("");

          setIsLoading(false);
        }}
        onCancel={() => {
          setIsModalOpen(false);

          form.resetFields();

          setPhoneValue("");

          setIsLoading(false);
        }}
        okText="OK"
        cancelButtonProps={{ style: { display: "none" } }}
      >
        <p>{submitMessage}</p>
      </Modal>
    </Space>
  );
};

export default ContactUs;
